export default () => {
	const app = useNuxtApp()
	return {
		thousandFormat(value: any): any {
			if (!value) return ""
			let v = ((value || "") + "") as string
			let v2 = ""
			let m = false
			if (v.includes(".")) {
				const i = v.indexOf(".")
				v2 = v.substring(i, v.length)
				v = v.substring(0, i)
			}
			if (v.includes("-")) {
				v = v.replace("-", "")
				m = true
			}
			v = v
				.replace(/,/g, "")
				.split("")
				.reverse()
				.join("")
				.replace(/(...)/g, "$1,")
				.split("")
				.reverse()
				.join("")
				.replace(/^,+|,+$/, "")
			if (m) v = "-" + v
			return v + v2
		},
		arabicToPersian(value: string): string {
			if (!value) return ""
			const characters = {
				ك: "ک",
				دِ: "د",
				بِ: "ب",
				زِ: "ز",
				ذِ: "ذ",
				شِ: "ش",
				سِ: "س",
				ى: "ی",
				ي: "ی",
				"١": "۱",
				"٢": "۲",
				"٣": "۳",
				"٤": "۴",
				"٥": "۵",
				"٦": "۶",
				"٧": "۷",
				"٨": "۸",
				"٩": "۹",
				"٠": "۰"
			} as any
			return value
				.split("")
				.map((v) => characters[v] || v)
				.join("")
		},
		getLocalText: (text?: { [key: string]: string } | null) => {
			return text?.[app.$i18n.locale] || text?.en || Object.values(text || {})?.filter((v) => v)[0] || undefined
		}
	}
}
